var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Layout',{attrs:{"hidden-overflow":""}},[_c('BaseContent',{class:_vm.$style.content},[(_vm.loggedIn)?_c('HomeAuth'):_c('HomeUnAuth')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }